
import { supabase } from "@/integrations/supabase/client";
import { useToast } from "@/components/ui/use-toast";

export const createOrUpdateCustomer = async (
  email: string, 
  name: string, 
  paymentLinkId: string, 
  userId: string | undefined,
  address?: string, 
  postcode?: string,
  phone?: string,
  paymentStatus: string = 'overdue',
  city?: string,
) => {
  try {
    const {
      data,
      error
    } = await supabase.from('customers').upsert([{
      user_id: userId,
      email: email,
      name: name,
      address: address,
      postcode: postcode,
      city: city,
      phone: phone,
      payment_link_id: paymentLinkId,
      payment_status: paymentStatus
    }]).select();
    if (error) {
      console.error("Error creating/updating customer:", error);
      return { success: false, error: error.message };
    } else {
      console.log("Customer created/updated successfully:", data);
      return { success: true, data };
    }
  } catch (error) {
    console.error("Unexpected error creating/updating customer:", error);
    return { success: false, error: 'Unexpected error occurred' };
  }
};
